export const NavigationTitle = {
  Auctions: 'Auctions',
  Artworks: 'Artworks',
  Artists: 'Artists',
  FAQ: 'FAQ',
  About: 'About',
} as const;

export const NavigationLink = {
  Auctions: 'auctions',
  Artworks: 'artworks',
  Artists: 'artists',
  FAQ: 'faq',
  About: 'about-us',
} as const;

export const navigationLinks = [
  {
    title: NavigationTitle.Auctions,
    link: NavigationLink.Auctions,
  },
  {
    title: NavigationTitle.Artworks,
    link: NavigationLink.Artworks,
  },
  {
    title: NavigationTitle.Artists,
    link: NavigationLink.Artists,
  },
  {
    title: NavigationTitle.FAQ,
    link: NavigationLink.FAQ,
  },
  {
    title: NavigationTitle.About,
    link: NavigationLink.About,
  },
] as const;
